import React, { createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import toast from 'react-hot-toast';
import { Input, Select, Spinner } from '../../../components';
import { classNames, Constants, delay, formatMiles, sanitizeToNumbers, roundConversion } from '../../../utils';
import { GeneralService, PurchasesService } from '../../../services';
import { Vector5 } from '../../../assets/img';
import { CloseIcon } from '../../../assets/icons';

const format = (amount) => {
	return parseFloat(parseFloat(amount).toFixed(2));
};

const getTotals = (total) => {
	const subtotal = format(total);
	let igtf = 0;
	let iva = 0;
	let amount = 0;

	// iva = format((total * Constants.TAXES.IVA) / 100);
	// igtf = format((total * Constants.TAXES.IGTF) / 100);
	amount = format(subtotal + igtf + iva);

	return { subtotal, igtf, iva, amount };
};

class PaymentTransfer extends React.Component {

	state = {
		isLoading: false,
		showConfirmModal: false,
		showOTPInput: false,
		request: this.props.request?.purchase,
		form: {
			paymentMethodId: Constants.PAYMENT.METHOD.TRANSFER,
			bankId: '',
			date: '',
			dniType: '',
			dni: '',
			phoneCode: '',
			phone: '',
			reference: '',
			conversion: 0,
			voucher: '',

			name: this.props.user.fullName,
			concept: '',
			otp: '',
			amountVED: 0,
			...getTotals(this.props.request?.purchase?.total),
		},
		banks: [],
		dniTypes: [],
		phoneCodes: [],
		continue_data: false,
		callback: null
	}

	confirmModalRef = createRef();
  cartButtonRef = createRef();
  goBack = createRef();

	componentDidMount() {
    this.cartButtonRef.current = document.getElementById('header-cart');
    this.cartButtonRef.current.classList.add('hidden');
    this.goBack.current = document.getElementById('header-goback');
    this.goBack.current.classList.remove('hidden');

    if (!this.props.request?.purchase) this.props.history.replace('/');

		this.getSelects();

		if (!this.props.request?.purchase) {
			this.props.history.replace('/historial/pagos');
		}
	}

  componentWillUnmount() {
    this.cartButtonRef.current.classList.remove('hidden');
    this.goBack.current.classList.add('hidden');
  }

	getSelects = async () => {
		Promise.all([
			GeneralService.getBanksOTP(),
			GeneralService.getDocumentTypes(),
			GeneralService.getPhoneCodes(),
			GeneralService.getConversion(),
		])
			.then(res => {
				const conversion = res[3].find(x => x.currency_id === Constants.CURRENCY.USD)?.amount ?? 0;

				this.setState({
					banks: res[0].map(x => ({ value: x.id, label: x.name })) ?? [],
					dniTypes: res[1] ?? [],
					phoneCodes: res[2] ?? [],
					form: {
						...this.state.form,
						amountVED: format(this.state.form.amount * roundConversion(conversion)),
						conversion,
					},
				});
			})
			.catch(console.log);
	}

	change = (value,target) => {
		this.setState({
			form: { ...this.state.form, [target]: value },
		});
	}

	getOtp = async () => {
		const { form } = this.state;
		await this.setState({ isLoading: true }); 

		const data = {
			type_dni: form.dniType,
			dni: form.dni,
			phone: `${form.phoneCode}${form.phone}`,
			amount: form.amountVED,
			bank_id: +form.bankId,
			name: form.name,
			concept: form.concept,
		};

		try {
			const res = await PurchasesService.getSyspagoOTP(data);
			if (res?.message) toast.error(res.message);
			this.setState({ showOTPInput: true });

			return true;

		} catch (error) {
			console.log(error);
			return false;
		} finally {
			await this.setState({ isLoading: false }); 
		}
	}

	confirmOtp = async () => {
		await this.setState({ isLoading: true }); 

		const { form } = this.state;

		const data = {
			type_dni: form.dniType,
			dni: form.dni,
			phone: `${form.phoneCode}${form.phone}`,
			amount: form.amountVED,
			bank_id: +form.bankId,
			name: form.name,
			concept: form.concept,
			otp: form.otp,
		};

		try {
			const res = await PurchasesService.confirmSyspagoOTP(data);
			if (res?.message) toast.error(res.message);
			if (!res?.response?.transaction_id) return false;

			this.change(res.reference, 'reference');
			await delay(1);
			return true;

		} catch (error) {
			return false;
		}
		finally {
			await this.setState({ isLoading: false }); 
		}
	}

	submit = async () => {
		if (!this.isValidForm()) return;

		if (!this.state.showOTPInput) {
			return this.getOtp();
		}

		if (!this.state.form.reference) {
			const otpCheck = await this.confirmOtp();
			if (!otpCheck) return;
		}

		const { form, request } = this.state;

		const data = {
			payment: {
				...form,
				date: moment(form.date).format('YYYY-MM-DD'),
			},
			request: {
				...request,
				conversion: form.conversion,
			},
			hasFile: false,
		};

		if (form.voucher) {
			data.hasFile = true;
			data.voucher = form.voucher;
			data.payment.voucher = undefined;
		}

		this.props.request?.products?.forEach(cartItem => {
			cartItem.beneficiaries.forEach(benef => {
				// Agrega los documentos requeridos a la raíz del objeto
				if (benef?.required_docs?.length) {
					benef?.required_docs.filter(x => !!x.file)?.forEach(x => {
						data.hasFile = true;
						const itemName = `required_docs_${x.id}_${benef.id}`;
						data[itemName] = x.file;
						data.request[itemName] = undefined;
					});
				}
			});
		});

		if (data.hasFile) {
			data.payment = JSON.stringify(data.payment);
			data.request = JSON.stringify(data.request);
		}

		try {
			await this.setState({ isLoading: true });
			const res = await PurchasesService.create(data);
			this.props.dispatch({ type: 'SET_REQUEST', payload: {} });
			this.props.dispatch({ type: 'SET_CART', payload: [] });
			this.confirmModalRef.current?.showModal();

			const continue_data = res.payment?.purchase?.purchase_products?.map(i => i.req_docs.length).reduce((a,b) => a + b,0) > 0 && res.payment?.face_identity_token !== undefined && res.payment?.vehicle_data == null && res.payment.status == Constants.PAYMENT.STATUS.APPROVED;
			this.setState({ continue_data, callback: () => {
				if (continue_data && res.payment) {
					this.props.history.push({
			      pathname: '/historial/pagos/completar',
			      state: {
			        item: res.payment
			      }
			    });
				}
				else {
					this.props.history.push('/');
				}
			} });

		} catch (error) {
			console.log(error);
		}
		await this.setState({ isLoading: false }); 
	}

	isValidForm = (showError = true) => {
		const onError = (msg) => {
			if (showError) toast.error(msg);
			return false;
		};

		const { form, showOTPInput } = this.state;

		if (!form.bankId)
			return onError('El banco es obligatorio');

		if (!form.dniType)
			return onError('El tipo de documento es obligatorio');

		if (!form.dni)
			return onError('La cédula es obligatoria');

		if (!form.phoneCode)
			return onError('El código de área es obligatorio');

		if (!form.phone)
			return onError('El teléfono es obligatorio');

		if (showOTPInput && !form.otp)
			return onError('El código OTP es obligatorio');

		return true;
	}

	closeConfirmModal = () => {
		this.confirmModalRef.current?.close();
		if (this.state.callback) {
			this.state.callback();
		}
		else {
			this.props.history.push('/');
		}
	}

	render() {

		const isNextStepEnabled = this.isValidForm(false);
		const { form, isLoading, showOTPInput } = this.state;

		return (
			<>
				{isLoading && (
					<div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
						<Spinner />
					</div>
				)}

				<dialog
					ref={this.confirmModalRef}
					className="fixed inset-0 z-50 overflow-y-auto bg-transparent"
					onClose={this.closeConfirmModal}
				>
					<div
						className="w-[20rem] bg-white rounded-xl overflow-hidden p-4 flex flex-col items-center"
						onClick={this.closeConfirmModal}
					>
						<button className="absolute top-3 right-3">
							<img src={CloseIcon} className="w-4 h-4 object-contain" alt="" />
						</button>

						<img src={Vector5} className="w-32 h-32 object-contain" alt="" />
						<p className="text-center font-semibold">
							Su pago se realizó con éxito
						</p>
						{/*{
							this.state.continue_data && (
								<p className="text-center font-semibold">Continúe con el proceso de llenado de datos</p>
							)
						}*/}
						<button
							className={classNames(
								'rounded-lg w-full text-center h-10 font-bold my-2 disabled:bg-gray6 disabled:text-gray3 bg-yellow text-black'
							)}
						>
							<span>Continuar</span>
						</button>
					</div>
				</dialog>

				<div className="w-full sm:w-[30rem] mx-auto flex flex-col gap-4 mt-8 lg:mt-0">
					<div className="w-full pt-2">
						<p className="text-center font-bold text-darkBlue text-3xl mb-2">
							{ formatMiles(form.amountVED,2,'Bs') }
						</p>

						<p className="font-semibold text-darkBlue mt-5 mb-2">
							Verificar pago
						</p>

						<div className="flex flex-col gap-y-4">
							<Select
								placeholder="Banco"
								items={this.state.banks}
								value={form.bankId}
								onValueChange={v => this.change(v,'bankId')}
							/>

							<div className="flex flex-row items-center">
								<div className="w-1/3">
									<Select
										items={this.state.dniTypes}
										value={form.dniType}
										onValueChange={v => this.change(v,'dniType')}
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Cédula"
										value={form.dni}
										onValueChange={v => this.change(sanitizeToNumbers(v),'dni')}
										maxLength={8}
									/>
								</div>
							</div>

							<div className="flex flex-row items-center">
								<div className="w-1/3">
									<Select
										items={this.state.phoneCodes}
										value={form.phoneCode}
										onValueChange={v => this.change(v,'phoneCode')}
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Número"
										value={form.phone}
										onValueChange={v => this.change(sanitizeToNumbers(v),'phone')}
										maxLength={7}
									/>
								</div>
							</div>

							<Input
								placeholder="Concepto de la transferencia (Opcional)"
								value={form.concept}
								onValueChange={v => this.change(v,'concept')}
							/>

							{showOTPInput && (
								<Input
									type="text"
									placeholder="Introduzca el código OTP"
									value={form.otp}
									onValueChange={v => this.change(v.replace(/\D/g, ''), 'otp')}
								/>
							)}
						</div>
					</div>

					<div>
						<button
							className={classNames(
								'rounded-lg w-full text-center h-10 font-bold my-2 disabled:bg-gray6 disabled:text-gray3',
								isNextStepEnabled ? 'bg-yellow text-black' : 'text-gray bg-gray6'
							)}
							onClick={this.submit}
							disabled={!isNextStepEnabled}
						>
							<span>Aceptar</span>
						</button>
					</div>
				</div>
			</>
		);
	}
}

export default connect(state => ({
	request: state.request,
	user: state.user,
}))(PaymentTransfer);
